// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"w1-z"};